import { createSlice } from "@reduxjs/toolkit";
import {
    createSubAccount, getSubAccounts, getSubAccountDetails,
    toggleAccountActivation, deleteSubAccount, subaccountChangePassword,
    getAssetSensorList, parentAllSensorList, parentSelectedSensorList,
    createShare,
    deleteShare, createMarkerShare, createZoneShare, deleteMarkerShare, deleteZoneShare,
    createReportShare, deleteReportShare, searchSubAccounts
} from "./subaccountApi";
const basicSensors = ['Engine', 'Main Power'];

export const subaccountSlice = createSlice({
    name: 'subaccount',
    initialState: {
        view: 'main',
        activeSubAccount: null,
        subaccountExists: [],
        subaccounts: [],
        error: null,
        createStatus: 'idle',
        createError: null,
        createErrorCode: null,
        createErrorDetails: null,
        listRequestId: null,
        detailRequestId: null,
        pendingSelectUsername: null,
        selectedAsset: null,
        sensorOptions: [],
        reloadAssets: false,
        reloadaccounts: false,
        reloadlist: true,
    },
    reducers: {
        changeView: (state, { payload }) => {
            //console.log("Reducer Change view to ", payload);
            state.view = payload;
            return state;
        },
        deselectActiveSubAccount: (state, { payload }) => {
            state.view = 'main';
            state.activeSubAccount = null;
            state.selectedAsset = null;
            state.sensorOptions = [];
            return state;
        },
        selectActiveSubAccount: (state, { payload }) => {
            //console.log("Active SA recuder", payload.username);
            state.activeSubAccount = payload;
            return state;
        },
        selectActiveAsset: (state, { payload }) => {
            state.selectedAsset = payload;
            //console.log("Selecte asset reducer", payload);
            return state;
        },
        setPendingSelectUsername: (state, { payload }) => {
            state.pendingSelectUsername = payload;
            return state;
        },
        resetCreateSubAccountState: (state) => {
            state.createStatus = 'idle';
            state.createError = null;
            state.createErrorCode = null;
            state.createErrorDetails = null;
            return state;
        },
        commitSubAccountMappings: (state, { payload }) => {
            const { subuser_id, zones, markers, reports } = payload || {};
            if (!state.activeSubAccount || state.activeSubAccount.subuser_id !== subuser_id) {
                return state;
            }

            state.detailRequestId = null;
            state.reloadaccounts = false;

            const parentUserId =
                state.activeSubAccount.zones?.[0]?.parent_user_id ||
                state.activeSubAccount.markers?.[0]?.parent_user_id ||
                state.activeSubAccount.reports?.[0]?.parent_user_id;

            if (Array.isArray(zones)) {
                state.activeSubAccount.zones = zones.map((zone_id) => ({
                    subuser_id,
                    parent_user_id: parentUserId,
                    zone_id: Number(zone_id),
                }));
            }
            if (Array.isArray(markers)) {
                state.activeSubAccount.markers = markers.map((marker_id) => ({
                    subuser_id,
                    parent_user_id: parentUserId,
                    marker_id: Number(marker_id),
                }));
            }
            if (Array.isArray(reports)) {
                state.activeSubAccount.reports = reports.map(({ type, name }) => ({
                    subuser_id,
                    parent_user_id: parentUserId,
                    type,
                    name,
                }));
            }
            return state;
        },
    },
    extraReducers: {
        [createSubAccount.pending]: (state, action) => {
            //console.log("Create SU pending");
            state.createStatus = 'pending';
            state.createError = null;
            state.createErrorCode = null;
            state.createErrorDetails = null;
            return state;
        },
        [createSubAccount.fulfilled]: (state, action) => {
            //console.log("Create SU done", action.payload);
            state.createStatus = 'success';
            state.createError = null;
            state.createErrorCode = null;
            state.createErrorDetails = null;
            state.reloadaccounts = true;
            state.reloadAssets = true;
            state.reloadlist = true;
            return state;
        },
        [createSubAccount.rejected]: (state, action) => {
            const payload = action.payload || {};
            const errorMessage =
                payload.message ||
                (typeof payload === 'string' ? payload : null) ||
                action.error?.message ||
                'Request failed.';
            state.createStatus = 'error';
            state.createError = errorMessage;
            state.createErrorCode = payload.code || null;
            state.createErrorDetails = payload.details || null;
            return state;
        },
        [getSubAccounts.pending]: (state, action) => {
            //console.log("Get SU pending");
            state.listRequestId = action.meta.requestId;
            return state;
        },
        [getSubAccounts.fulfilled]: (state, action) => {
            //console.log("Got Subusers", action.payload);
            if (state.listRequestId && state.listRequestId !== action.meta.requestId) {
                return state;
            }
            const { payload } = action;
            if (payload && payload.error) {
                if (state.view === 'main') {
                    state.view = "main";
                }
                state.subaccounts = [];
            }
            const results = payload?.subaccounts || payload?.subusers;
            if (payload && (payload.result || results)) {
                if (state.view === 'main') {
                    state.view = 'main';
                }
                //console.log("Got SU recucer", payload.subaccounts.length)
                state.subaccounts = results || [];

            }
            if (state.pendingSelectUsername && state.subaccounts.length > 0) {
                const target = state.subaccounts.find(
                    (subaccount) =>
                        `${subaccount.username}`.toLowerCase() ===
                        `${state.pendingSelectUsername}`.toLowerCase()
                );
                if (target) {
                    state.activeSubAccount = target;
                    state.pendingSelectUsername = null;
                }
            }
            state.reloadlist = false;
            state.listRequestId = null;
            //state.reloadaccounts = false;
            //state.reloadAssets = false;
            return state;
        },
        [getSubAccounts.rejected]: (state, action) => {
            //console.log("Action SU list error", action.payload);
            if (state.listRequestId && state.listRequestId !== action.meta.requestId) {
                return state;
            }
            state.error = action.payload?.error || action.payload || action.error?.message;
            if (state.view === 'main') {
                state.view = 'main';
            }
            state.listRequestId = null;
            return state;
        },
        [searchSubAccounts.pending]: (state, action) => {
            //console.log("Search SU pending");
            state.listRequestId = action.meta.requestId;
            return state;
        },
        [searchSubAccounts.fulfilled]: (state, action) => {
            if (state.listRequestId && state.listRequestId !== action.meta.requestId) {
                return state;
            }
            const { payload } = action;
            if (payload && payload.error) {
                if (state.view === 'main') {
                    state.view = "main";
                }
                state.subaccounts = [];
            }
            const results = payload?.subaccounts || payload?.subusers;
            if (payload && (payload.result || results)) {
                if (state.view === 'main') {
                    state.view = 'main';
                }
                state.subaccounts = results || [];
            }
            state.reloadlist = false;
            state.listRequestId = null;
            return state;
        },
        [searchSubAccounts.rejected]: (state, action) => {
            if (state.listRequestId && state.listRequestId !== action.meta.requestId) {
                return state;
            }
            const payloadError = action.payload?.error || action.payload;
            state.error = payloadError || action.error?.message;
            if (state.view === 'main') {
                state.view = 'main';
            }
            state.listRequestId = null;
            return state;
        },
        [getSubAccountDetails.pending]: (state, action) => {
            //console.log("Get SU detail pending");
            state.detailRequestId = action.meta.requestId;
            return state;
        },
        [getSubAccountDetails.fulfilled]: (state, action) => {
            if (state.detailRequestId !== action.meta.requestId) {
                return state;
            }
            const { payload } = action;
            //console.log("Got Subuser details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            if (payload && payload.result) {
                state.activeSubAccount = payload.subaccount;
            }
            state.reloadaccounts = false;
            state.reloadAssets = false;
            state.detailRequestId = null;
            //console.log("Got SU Reducer", payload.subaccount.username, "A", payload.subaccount.active);
            return state;
        },
        [getSubAccountDetails.rejected]: (state, action) => {
            if (state.detailRequestId !== action.meta.requestId) {
                return state;
            }
            //console.log("Action SU detail error", action.payload);
            state.error = action.payload?.error || action.payload || action.error?.message;
            state.detailRequestId = null;
            return state;
        },
        [toggleAccountActivation.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [toggleAccountActivation.fulfilled]: (state, action) => {
            //console.log("Togg Avtivation", payload);
            const { payload } = action;
            if (payload && payload.error) {
                state.error = payload.error;
            }
            state.reloadaccounts = true;
            state.reloadlist = true;
            const updated = action.meta?.arg;
            if (updated && typeof updated.active !== 'undefined') {
                const targetIndex = state.subaccounts.findIndex(
                    (subaccount) => subaccount.subuser_id === updated.subuser_id
                );
                if (targetIndex !== -1) {
                    state.subaccounts[targetIndex] = {
                        ...state.subaccounts[targetIndex],
                        active: updated.active,
                    };
                }
                if (state.activeSubAccount && state.activeSubAccount.subuser_id === updated.subuser_id) {
                    state.activeSubAccount = {
                        ...state.activeSubAccount,
                        active: updated.active,
                    };
                }
            }
            //console.log("Togg Avtivation", payload);
            return state;
        },
        [toggleAccountActivation.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            //state.reloadaccounts = true;
            return state;
        },
        [deleteSubAccount.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [deleteSubAccount.fulfilled]: (state, { payload }) => {
            //console.log("Togg Avtivation", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            state.view = 'main';
            state.activeSubAccount = null;
            state.selectedAsset = null;
            state.sensorOptions = [];
            state.reloadlist = true;
            //console.log("Delete Account", payload);
            return state;
        },
        [deleteSubAccount.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            //state.reloadaccounts = true;
            return state;
        },
        [subaccountChangePassword.pending]: (state, action) => {
            //console.log("Get subaccountChangePassword pending");
            return state;
        },
        [subaccountChangePassword.fulfilled]: (state, { payload }) => {
            if (payload && payload.error) {
                state.error = payload.error;
            }
            //console.log("subaccountChangePassword", payload);
            return state;
        },
        [subaccountChangePassword.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            //state.reloadaccounts = true;
            return state;
        },
        [getAssetSensorList.pending]: (state, action) => {
            //console.log("Get SU asset sensors pending");
            return state;
        },
        [getAssetSensorList.fulfilled]: (state, { payload }) => {
            //console.log("Got SU asset sensors details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            if (payload && payload.result) {
                state.sensorOptions = payload.sensors;
            }
        },
        [getAssetSensorList.rejected]: (state, action) => {
            //console.log("Action SU asset sensors error", action);
            state.sensorOptions = [];
            state.error = action.payload.error;
            return state;
        },
        [parentAllSensorList.pending]: (state, action) => {
            //console.log("Get SU all sensors pending");
            return state;
        },
        [parentAllSensorList.fulfilled]: (state, { payload }) => {
            //console.log("Got SU all sensors details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            if (payload && payload.result) {
                state.sensorOptions = payload.sensors;
            }
        },
        [parentAllSensorList.rejected]: (state, action) => {
            //console.log("Action SU all sensors error", action.payload);
            state.sensorOptions = [];
            state.error = action.payload.error;
            return state;
        },
        [parentSelectedSensorList.pending]: (state, action) => {
            //console.log("Get SU all sensors pending");
            return state;
        },
        [parentSelectedSensorList.fulfilled]: (state, { payload }) => {
            //console.log("Got SU all sensors details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            if (payload && payload.result) {
                //console.log("payload", payload.sensors);
                const filterSensors = payload.sensors.filter(s => basicSensors.indexOf(s) === -1);
                state.sensorOptions = filterSensors;
            }
        },
        [parentSelectedSensorList.rejected]: (state, action) => {
            //console.log("Action SU all sensors error", action.payload);
            state.sensorOptions = [];
            state.error = action.payload.error;
            return state;
        },
        [createShare.pending]: (state, action) => {
            //console.log("Get CReate Share pending");
            return state;
        },
        [createShare.fulfilled]: (state, { payload }) => {
            //console.log("Got CReate Share details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            state.reloadaccounts = true;
            state.reloadAssets = true;
            return state;
        },
        [createShare.rejected]: (state, action) => {
            //console.log("Action CReate Share error", action.payload);
            state.sensorOptions = [];
            state.error = action.payload.error;
            state.reloadAssets = true;
            return state;
        },
        [deleteShare.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [deleteShare.fulfilled]: (state, { payload }) => {
            //console.log("Got DElete Share details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            state.reloadaccounts = true;
            state.reloadAssets = true;
            return state;
        },
        [deleteShare.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.sensorOptions = [];
            state.error = action.payload.error;
            state.reloadaccounts = true;
            state.reloadAssets = true;
            return state;
        },

        [createMarkerShare.pending]: (state, action) => {
            //console.log("Get CReate Share pending");
            return state;
        },
        [createMarkerShare.fulfilled]: (state, { payload }) => {
            //console.log("Got CReate Share details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            return state;
        },
        [createMarkerShare.rejected]: (state, action) => {
            //console.log("Action CReate Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },
        [deleteMarkerShare.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [deleteMarkerShare.fulfilled]: (state, { payload }) => {
            //console.log("Got DElete Share details", payload);
            if (payload && payload.error) {
                state.sensorOptions = [];
                state.error = payload.error;
            }
            return state;
        },
        [deleteMarkerShare.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },
        [createZoneShare.pending]: (state, action) => {
            //console.log("Get CReate Share pending");
            return state;
        },
        [createZoneShare.fulfilled]: (state, { payload }) => {
            //console.log("Got CReate Share details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            return state;
        },
        [createZoneShare.rejected]: (state, action) => {
            //console.log("Action CReate Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },
        [deleteZoneShare.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [deleteZoneShare.fulfilled]: (state, { payload }) => {
            //console.log("Got DElete Share details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            return state;
        },
        [deleteZoneShare.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },
        [createReportShare.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [createReportShare.fulfilled]: (state, { payload }) => {
            //console.log("Got Create Share details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            return state;
        },
        [createReportShare.rejected]: (state, action) => {
            //console.log("Action DElCreate Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },
        [deleteReportShare.pending]: (state, action) => {
            //console.log("Get DElete Share pending");
            return state;
        },
        [deleteReportShare.fulfilled]: (state, { payload }) => {
            //console.log("Got DElete Share details", payload);
            if (payload && payload.error) {
                state.error = payload.error;
            }
            return state;
        },
        [deleteReportShare.rejected]: (state, action) => {
            //console.log("Action DElete Share error", action.payload);
            state.error = action.payload.error;
            return state;
        },

    },
})

export const subAccountViewSelector = state => state.subaccount.view;
export const subaccountListSelector = state => state.subaccount.subaccounts;
export const activeSubAccountSelector = state => state.subaccount.activeSubAccount;
export const createSubAccountStatusSelector = state => state.subaccount.createStatus;
export const createSubAccountErrorSelector = state => state.subaccount.createError;
export const createSubAccountErrorCodeSelector = state => state.subaccount.createErrorCode;
export const createSubAccountErrorDetailsSelector = state => state.subaccount.createErrorDetails;
export const selectedAssetSelector = state => state.subaccount.selectedAsset;
export const sensorOptionsSelector = state => state.subaccount.sensorOptions;
export const reloadAccountsSelector = state => state.subaccount.reloadaccounts;
export const reloadAssetsSelector = state => state.subaccount.reloadAssets;
export const reloadlistSelector = state => state.subaccount.reloadlist;

export const { changeView, selectActiveSubAccount, deselectActiveSubAccount,
    selectActiveAsset, resetCreateSubAccountState, setPendingSelectUsername, commitSubAccountMappings,
} = subaccountSlice.actions;

export {
    createSubAccount, getSubAccounts, getSubAccountDetails,
    toggleAccountActivation, deleteSubAccount, subaccountChangePassword,
    getAssetSensorList, parentAllSensorList, parentSelectedSensorList,
    createShare,
    deleteShare, createMarkerShare, createZoneShare, deleteMarkerShare, deleteZoneShare,
    createReportShare, deleteReportShare, searchSubAccounts
};
